<template>
  <div class="language-switcher">
    <button 
      class="btn btn-sm"
      :class="{ active: locale === 'fr' }"
      @click="changeLanguage('fr')"
    >
      FR
    </button>

    <button 
      class="btn btn-sm"
      :class="{ active: locale === 'en' }"
      @click="changeLanguage('en')"
    >
      EN
    </button>
  </div>
  <div class="clearfix"  v-if="!pageLoad">
      <div class="spinner-grow text-danger " style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
  </div>
  <div v-if="pageLoad" class="row justify-content-center" style="margin-top: -8%;">
    <div class="col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6">
      <div class="card mb-25 border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing">
          <h4 class="text-black fw-bold mb-0 text-center">
            {{ t('auth.loginToAccount')}}
          </h4>
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>              
              
            </div>
          <form ref="form" @submit.prevent="login" >
            
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    {{ t('auth.emailAddress')}} 
                  </label>
                  <input
                    type="email"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. adam127704@gmail.com"
                    v-model="formValues.email"
                    @blur="validate('email')"
                    @keypress="validate('email')"
                    :class="{ 'is-invalid': errorsBis['email'] }"
                  />
                  <span class="invalid-feedback">{{ errorsBis['email']}}</span>

            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                {{ t('auth.password')}}
              </label>
              <input
                id="password"
                type="password"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="**************"
                v-model="formValues.password"  
                @blur="validate('password')"
                @keypress="validate('password')"
                :class="{ 'is-invalid': errorsBis['password'] }"             
              />              
              <span class="invalid-feedback">{{ errorsBis['password']}}</span>
              <div id="password-hidden">
                  <i class="flaticon-view" v-if="check" check id="togglePassword" @click="togglePassword"></i>
                  <i class="flaticon-eye-1"  v-if="!check" id="togglePassword" @click="togglePassword"></i>
              </div>
            </div>
            <div
              class="d-flex align-items-center justify-content-between mb-15 mb-md-20"
            >
              <div
                class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1"
              >
              </div>
              <router-link
                to="/forgot-password"
                class="forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
              >
                {{ t('auth.forgotPassword')}}
              </router-link>
            </div>
            <button
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100"
              type="submit"
              style="background-color: #EB9355;" :disabled="!btnLoad"
            >
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            {{ t('auth.loginNow')}} 
            </button>
            <span
              class="d-block text-muted text-center mt-15 mt-md-30 mb-12 mb-md-20 fs-md-15 fs-lg-16"
            >
            {{ t('auth.noAccount')}}
            </span>
            <router-link
              to="/register"
              class="default-btn with-border transition fw-medium rounded-1 fs-md-15 fs-lg-16 d-block w-100 text-decoration-none text-center"
              
            >
            {{ t('auth.createAccount')}}
            </router-link>
           
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import router from '@/router';
import axios from 'axios';
import { ref, reactive, onMounted, inject } from 'vue';
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import data from '../../../../env.json'
import { formatNumber } from "../../../utils/function";
import stateStore from "../../../utils/store";

const stateStoreInstance = stateStore;
stateStoreInstance.setRole('ok')

const email = ref('');
const password = ref('');
const error = ref('');
const errors = ref('');
const errorId = ref('');
const errorsBis = {'email':'', 'password':''};
let result = true;
let dataJson = [];
const pageLoad = ref(false);
const btnLoad = ref(true);
const check = ref(true);
const { locale, t } = useI18n();
const transactions = ref(true);
const backApi = inject('back');
console.log('API Backend URL:', backApi)

// Schéma de validation Yup
const schema = yup.object({
    password: yup.string()
        .required(t('validationform.passwordRequired'))
        .min(6, t('validationform.passwordMinLength5')),
    email: yup.string()
        .email(t('validationform.emailValid'))
        .required(t('validationform.emailRequired')),
});

const formValues = reactive({
    email: "",
    password: "",
});

// Fonction pour changer la langue
const changeLanguage = (lang) => {
    locale.value = lang;
    localStorage.setItem("lang", lang);
};

// Validation d'un champ spécifique
function validate(field) {
    schema
        .validateAt(field, formValues)
        .then(() => {
            errorsBis[field] = "";
        })
        .catch(err => {
            errorsBis[field] = err.message;
        });
    errors.value = '';
}

// Validation du formulaire complet
function validateForm() {
    let isValid = true;
    for (var data in errorsBis) {
        schema
            .validateAt(data, formValues)
            .then(() => {
                errorsBis[data] = "";
            })
            .catch(err => {
                errorsBis[data] = err.message;
                isValid = false;
            });
    }
    return isValid;
}

// Formatage des dates
function formatDateEn(value, d = 0) {
    if (value) {
        const year = value.getFullYear();
        let month = value.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let day = value.getDate() + d;
        day = day < 10 ? '0' + day : day;
        return year + '-' + month + '-' + day;
    }
}

function getPeriod(value) {
    if (value) {
        const year = value.getFullYear();
        let month = value.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        return year + '-' + month;
    }
}

// Normalise le tableau "actions" renvoyé par le backend en un tableau
// de simples chaînes de codes de permission.
function normalizePermissions(actions) {
    if (!Array.isArray(actions)) return [];
    return actions
        .map((a) => {
            if (typeof a === 'string') return a.trim();
            if (a && typeof a === 'object') return (a.code || a.route || '').toString().trim();
            return '';
        })
        .filter(Boolean);
}

// Fonction de connexion
const login = async () => {
    try {
        // Validation du formulaire
        await schema.validate(formValues, { abortEarly: false });
        
        btnLoad.value = false;
        
        // Appel de connexion
        const loginResponse = await axios.post(`${backApi}/login`, {
            email: formValues.email,
            password: formValues.password
        }, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (loginResponse.status === 200) {
            console.log('CONNEXION REUSSIE CONNEXION REUSSIE CONNEXION REUSSIE CONNEXION REUSSIE:', loginResponse.data);

            // Extraction des données
            const { token, organization, code, name, email, status, role, actions } = loginResponse.data;
            const organizationCode = organization.code;
            localStorage.removeItem('organization_code');
            console.log('Permissions brutes reçues du backend (actions):', actions);

            const normalizedPermissions = normalizePermissions(actions);
            console.log('Permissions normalisées stockées:', normalizedPermissions);

            reset();

            // Stockage des informations utilisateur
            localStorage.setItem('login_token', token);
            localStorage.setItem('organization_code', organizationCode);
            localStorage.setItem('organization_name', organization.name);
            localStorage.setItem('code', code);
            localStorage.setItem('name', name);
            localStorage.setItem('email', email);
            localStorage.setItem('status', status);
            localStorage.setItem('role', role);
            localStorage.setItem('permissions', JSON.stringify({ permissions: normalizedPermissions }));
            
            // Mise à jour du store
            stateStoreInstance.setRole(role);
            
            // Préparation des dates
            const day = new Date();
            const todayE = getPeriod(day);
            localStorage.setItem('startingDate', Date.now());
            
            // 1. Récupération des statistiques
            try {
                const statsResponse = await axios.get(
                    `${backApi}/secure/organizations/statistic?dateD=${todayE}&dateF=${todayE}&organization=${organizationCode}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                
                dataJson = statsResponse.data;
                console.log('Données statistiques:', dataJson);
                
                localStorage.setItem('organizationDonut', JSON.stringify({ donut: dataJson.organizationDonut }));
                localStorage.setItem('organizationChartbyMonth', JSON.stringify({ chart: dataJson.monthyChart || [] }));
                localStorage.setItem('weekChart', JSON.stringify({ chart: dataJson.weekChart || [] }));
                localStorage.setItem('day', dataJson.day);
                localStorage.setItem('weekBalance', dataJson.weekBalance);
                
            } catch (error) {
                console.error('Erreur lors de la récupération des statistiques:', error.response?.data || error.message);
                if (error.response?.status === 401) {
                    router.push('/');
                    return;
                }
            }
            
            // 2. Récupération du solde disponible
            try {
                const balanceResponse = await axios.post(
                    `${backApi}/secure/accounts/balance/available`,
                    { organization: organizationCode },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                
                console.log('Solde disponible:', balanceResponse.data.balance);
                const balanceTemp = formatNumber(parseInt(balanceResponse.data.balance));
                localStorage.setItem('availableBalance', balanceTemp);
                
            } catch (error) {
                console.error('Erreur lors de la récupération du solde disponible:', error.response?.data || error.message);
            }
            
            // 3. Récupération du solde collect
            try {
                const collectResponse = await axios.post(
                    `${backApi}/secure/accounts/balance/collect`,
                    { organization: organizationCode },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                
                console.log('Solde collect:', collectResponse.data);
                const balanceTemp1 = formatNumber(parseInt(collectResponse.data.balance));
                localStorage.setItem('collectBalance', balanceTemp1);
                
            } catch (error) {
                console.error('Erreur lors de la récupération du solde collect:', error.response?.data || error.message);
            }
            
            // 4. Récupération du solde payout
            try {
                const payoutResponse = await axios.post(
                    `${backApi}/secure/accounts/balance/payout`,
                    { organization: organizationCode },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                
                console.log('Solde payout:', payoutResponse.data);
                const balanceTemp2 = formatNumber(parseInt(payoutResponse.data.balance));
                localStorage.setItem('balance', balanceTemp2);
                
            } catch (error) {
                console.error('Erreur lors de la récupération du solde payout:', error.response?.data || error.message);
            }
            
            // 5. Récupération des comptes utilisateur
            try {
                const merchantsResponse = await axios.get(
                    `${backApi}/secure/merchants/?organization=${organizationCode}&user=${code}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                
                const accounts = merchantsResponse.data;
                console.log('Comptes utilisateur:', accounts);
                
                localStorage.setItem('account_size', accounts.length);
                localStorage.setItem('personnal_account_status', accounts.length > 0 ? accounts[0].status : "INACTIVE");
                
            } catch (error) {
                console.error('Erreur lors de la récupération des comptes:', error.response?.data || error.message);
            }

            // AJOUTÉ / DÉPLACÉ ICI : on ne dispatch 'user-login' qu'une fois
            // TOUTES les infos de la nouvelle session écrites dans le
            // localStorage. C'est cet événement que Header.vue écoute pour
            // se rafraîchir ; il doit donc partir en dernier.
            window.dispatchEvent(new CustomEvent('user-login'));
            
            // Redirection vers le dashboard
            btnLoad.value = true;
            router.push('/dashboard');
        }
        
    } catch (error) {
        btnLoad.value = true;
        
        // Gestion des erreurs de validation Yup
        if (error.name === 'ValidationError') {
            error.inner.forEach(err => {
                errorsBis[err.path] = err.message;
            });
            errors.value = t('validationform.validationFailed');
            return;
        }
        
        // Gestion des erreurs Axios
        if (error.response) {
            console.error('Erreur API:', error.response.data);
            errorId.value = error.response.data.errorId || '';
            errors.value = error.response.data.message || t('errors.unexpectedError');
        } else if (error.request) {
            console.error('Erreur réseau:', error.request);
            errors.value = t('errors.networkError');
        } else {
            console.error('Erreur:', error.message);
            errors.value = t('errors.unexpectedError');
        }
    }
};

// Fonction de réinitialisation
const reset = async () => {
    try {
        localStorage.removeItem('login_token');
        localStorage.removeItem('organization_code');
        localStorage.removeItem('organization_name');
        localStorage.removeItem('name');
        localStorage.removeItem('email');
        localStorage.removeItem('status');
        localStorage.removeItem('role');
        localStorage.removeItem('permissions');
        localStorage.removeItem('organizationDonut');
        localStorage.removeItem('organizationChartbyMonth');
        localStorage.removeItem('weekChart');
        localStorage.removeItem('day');
        localStorage.removeItem('weekBalance');
        localStorage.removeItem('dailyBalance');
        localStorage.removeItem('availableBalance');
        localStorage.removeItem('collectBalance');
        localStorage.removeItem('balance');
        localStorage.removeItem('account_size');
        localStorage.removeItem('personnal_account_status');
        localStorage.removeItem('startingDate');
    } catch (error) {
        console.error('Erreur lors de la réinitialisation:', error);
    }
};

// Fonction pour afficher/masquer le mot de passe
const togglePassword = () => {
    const passwordInput = document.getElementById('password');
    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        check.value = false;
    } else {
        passwordInput.type = 'password';
        check.value = true;
    }
};

// Cycle de vie du composant
onMounted(() => {
    reset();
    setTimeout(() => {
        pageLoad.value = true;
    }, 1000);
});
</script>


<style scoped>
#password-hidden{
  display: flex;
  align-items: center;
  position: absolute;
  top: 46%;
  right: 16%;
}

.language-switcher {
  position: fixed;
  top: 20px;
  right: 25px;
  z-index: 9999;
  display: flex;
  gap: 5px;
}

.language-switcher button {
  border: 1px solid #EB9355;
  background: white;
  color: #EB9355;
  font-weight: 600;
}

.language-switcher button.active {
  background-color: #EB9355;
  color: white;
}

</style>